import React, { Component } from 'react';
import { Modal, Row, Col, Spin, InputNumber, Select, message, Tooltip } from 'antd';
import SearchInput from '../../../common/SearchInput';
import Text from '../../../basicElement/Text';
import VisitWindow from './VisitWindow';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';
import genConfig from '../../../shared/genConfig';
import { getMatchOption, generateOptions } from '../../../shared/selectFn';
import { DateType, SymbolType, VisitTypeTimeUnit, HourType } from '../constants';

const width = 200;
const { Option } = Select;
const toString = value => value ? String(value) : undefined;
const hasValue = value => (value || value === 0) ? true : false;
const DateTypeOption = generateOptions(DateType);
const HourTypeOption = generateOptions(HourType);
const VisitTypeTimeUnitOption = generateOptions(VisitTypeTimeUnit);
const Enums = ['first', 'second', 'third'];
const DefaultData = {
    visitTypeTimeUnit: 'DAY',
    visitTypeWindowDateType: 'DAY',
    firstWindowSymbol: 'floor',
    secondWindowSymbol: 'ceil',
};

const getVisitWindowValue = (value, tier, params) => {
    if (value >= 0) {
        params[`${Enums[tier]}WindowSymbol`] = 'ceil';
        params[`${Enums[tier]}WindowValue`] = value;
    } else {
        params[`${Enums[tier]}WindowSymbol`] = 'floor';
        params[`${Enums[tier]}WindowValue`] = Math.abs(value);
    }
};

class Update extends Component {
    state = {
        visible: false,
        data: {},
        stageList: [],
        compareBasicList: [],
        loading: false,
        type: '',
        serviceList: [],
        categoryList: [],
        visitingTypeList: [],
        visitCountOption: [],
        visitCommentOption: [],
        // visitCommentList: [],
    }

    show = (record, type) => {
        this.setState({
            type,
            visible: true,
            data: this.adaptData(record, type),
        }, () => {
            this.queryStage();          //访视阶段
            this.queryCompareBasic();   //对照基准
            this.queryCategory();       //访视类别
            // this.queryVisitCommentList();      //访视备注
            type === 'edit' && this.queryType();    //访视类型
        });
    }

    adaptData = (record, type) => {
        let data;
        if (type === 'add') {
            return data = { ...DefaultData };
        } else {
            const {
                visitTypeId, visitStageId, visitPeriodId, visitingTypeId, visitTypeName, referenceVisitTypeId,
                visitTypeWindow, visitTypeWindowDateType, visitTypeWindowFloor, visitTypeWindowCeil,
                visitTypeTimeUnit, visitHour, visitCategory, planVisitSummaryId, visitComment,
            } = record;
            data = {
                ...DefaultData,
                visitTypeId,
                visitStageId,
                visitPeriodId,
                visitTypeName,
                referenceVisitTypeId,
                visitTypeWindow,
                visitHour,
                visitingTypeId,
                visitCategory,
                planVisitSummaryId,
                visitComment,
            };
            if (visitTypeWindowDateType) {
                data.visitTypeWindowDateType = visitTypeWindowDateType;
            }
            if (visitTypeTimeUnit) {
                data.visitTypeWindowDateType = visitTypeTimeUnit == 'DAY' ? (visitTypeWindowDateType || 'DAY') : (visitTypeWindowDateType || 'HOUR');
                data.visitTypeTimeUnit = visitTypeTimeUnit;
            }
            if (visitTypeWindowFloor || visitTypeWindowFloor === 0) {
                getVisitWindowValue(visitTypeWindowFloor, 0, data);
                getVisitWindowValue(visitTypeWindowCeil, 1, data);
            }
            return data;
        }
    }

    hide = () => {
        this.setState({
            visible: false,
            data: {},
            stageList: [],
            compareBasicList: [],
            serviceList: [],
            categoryList: [],
            visitCountOption: [],
        });
    }

    // 查询访视类别
    queryCategory = () => {
        const { evaluateRecordId } = this.props;
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.queryVisitCategoryForAddVisit,
            data: { evaluateRecordId, limit: 99999 },
            dataType: 'json',
            doneResult: res => {
                this.setState({ categoryList: res.datas });
            },
        });
    }

    // // 查询访视备注
    // queryVisitCommentList = () => {
    //     $.sendRequest({
    //         method: 'POST',
    //         url: API_URL.evaluate.queryConfigWithChildByType,
    //         data: { type: 'VISIT_COMMENT' },
    //         dataType: 'json',
    //         doneResult: res => {
    //             this.setState({ visitCommentList: res.list });
    //         },
    //     });
    // }

    // 查询访视阶段
    queryStage = () => {
        const { visitGroupingId } = this.props;
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.queryVisitStageWithPeriod,
            data: { visitGroupingId },
            dataType: 'json',
            doneResult: res => {
                this.setState({ stageList: res.visitStageList });
            },
        });
    }

    // 查询访视类型
    queryType = () => {
        const { evaluateRecordId, visitGroupingId } = this.props;
        const { data: { visitCategory } } = this.state;
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.queryVisitingNameForAddVisit,
            data: { 
                visitGroupingId,
                evaluateRecordId,
                visitCategory,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ visitingTypeList: res.datas });
            },
        });
    }

    // 查询对照基准
    queryCompareBasic = () => {
        const { data } = this.props;
        this.setState({ compareBasicList: data });
    }

    handleChange = (value, key) => {
        const { data, visitingTypeList } = this.state;
        switch (key) {
            case 'visitStageId': {
                data.visitStageId = value;
                data.visitPeriodId = undefined;
                break;
            }
            case 'visitTypeTimeUnit': {
                data.visitTypeTimeUnit = value;
                if(value == 'HOUR'){
                    data.visitTypeWindow = data.visitTypeWindow ? Math.floor(data.visitTypeWindow * (data.visitTypeWindowDateType == 'DAY' ? 24 : data.visitTypeWindowDateType == 'WEEK' ? 24 *7 : data.visitTypeWindowDateType == 'MONTH' ? 24 * 30 : 1)): undefined;
                    data.firstWindowValue = data.firstWindowValue ? Math.floor(data.firstWindowValue * 24) : undefined;
                    data.secondWindowValue = data.secondWindowValue ? Math.floor(data.secondWindowValue * 24): undefined;
                }
                else if(value == 'DAY')
                {
                    data.visitTypeWindow = data.visitTypeWindow ? Math.floor(data.visitTypeWindow / (data.visitTypeWindowDateType == 'HOUR' ? 24 : data.visitTypeWindowDateType == 'WEEK' ? 24 *7 : data.visitTypeWindowDateType == 'MONTH' ? 24 * 30 : 1)) : undefined;
                    data.firstWindowValue = data.firstWindowValue ? Math.floor(data.firstWindowValue / 24) :undefined;
                    data.secondWindowValue = data.secondWindowValue ? Math.floor(data.secondWindowValue / 24) :undefined;
                }
                data.visitTypeWindowDateType = value == 'HOUR' ? 'HOUR' : 'DAY';
                break;
            }
            case 'visitCategory': {
                data.visitCategory = value;
                data.visitingTypeId = undefined;
                break;
            }
            case 'visitingTypeId': {
                data.visitingTypeId = value;
                const list = (visitingTypeList || []).filter(el => el.visitingTypeId == value);
                data.visitHour = value ? list[0].visitHour : undefined;
                break;
            }
            default: {
                data[key] = value;
                break;
            }
        }
        this.setState({
            data,
        },() => {
            if (key === 'visitCategory' && value) {
                this.queryType();  // 查询访视类型
            }
        });
    }

    visitCountSelectChange = value => {
        const { data } = this.state;
        if (value == undefined) {
            data.visitTypeName = undefined;
        } else {
            data.visitTypeName = value.key;
        }
        this.setState({ data });
    }

    parseVisitCountData = (res, value) => {
        if (res.visitingFrequencyList) {
            const data = (res.visitingFrequencyList || []).map(item => ({
                text: item.configValue,
                value: item.configValue,
            }));
            this.setState({ visitCountOption: data });
        } else {
            this.setState({ visitCountOption: [] });
        }
    }

    visitCommentSelectChange = value => {
        const { data } = this.state;
        if (value == undefined) {
            data.visitComment = undefined;
        } else {
            data.visitComment =  value.key;
        }
        this.setState({ data });
    }

    parsevisitCommentData = (res, value) => {
        if (res.list) {
            const data = (res.list || []).map(item => ({
                text: item.configureValue,
                value: item.configureValue,
            }));
            this.setState({ visitCommentOption: data });
        } else {
            this.setState({ visitCommentOption: [] });
        }
    }

    submit = () => {
        const { visitGroupingId } = this.props;
        const { data } = this.state;
        const {
            firstWindowSymbol,
            firstWindowValue,
            secondWindowSymbol, 
            secondWindowValue, 
            ...rest
        } = data;
        if (!rest.visitStageId) {
            return message.warning('阶段名称不能为空!');
        }
        if (!rest.visitCategory) {
            return message.warning('访视类别不能为空!');
        }
        if (!rest.visitingTypeId) {
            return message.warning('访视类型不能为空!');
        }
        if (!rest.visitStageId) {
            return message.warning('阶段名称不能为空!');
        }
        if (!rest.visitHour) {
            return message.warning('访视工时不能为空!');
        }
        if (!rest.visitTypeName) {
            return message.warning('访视次数不能为空!');
        }
        if (!rest.visitTypeTimeUnit) {
            return message.warning('访视时间维度不能为空!');
        }
        if (
            (hasValue(firstWindowValue) && !hasValue(secondWindowValue)) ||
            (!hasValue(firstWindowValue) && hasValue(secondWindowValue))
        ) {
            return message.warning('访视窗口必须成对填写，请填写上边界或下边界的值，可以填写0');
        }
        if (firstWindowValue || firstWindowValue === 0) {
            rest.visitTypeWindowFloor = Number(SymbolType[firstWindowSymbol] + firstWindowValue);
            rest.visitTypeWindowCeil = Number(SymbolType[secondWindowSymbol] + secondWindowValue);
            if (rest.visitTypeWindowFloor > rest.visitTypeWindowCeil) {
                return message.warning('访视窗口的第一项值不能大于第二项值');
            }
        }

        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.addVisitType,
            data: {
                ...rest,
                visitGroupingId,
                // visitCommentId: visitCommentList.filter(el => el.configureValue == visitComment)[0].evaluateConfigureId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    render() {
        const { visitGroupingId } = this.props;
        const {
            visible,
            loading,
            stageList,
            compareBasicList,
            data,
            visitCountOption,
            visitCommentOption,
            type,
            categoryList,
            visitingTypeList,
        } = this.state;
        const { 
            visitStageId, 
            visitTypeName, 
            visitCategory, 
            visitHour, 
            visitingTypeId,
            visitComment,
        } = data;
        const { visitPeriodList: periodList } = getMatchOption(stageList, 'visitStageId', visitStageId);

        const stageOption = stageList.map(item => <Option key={item.visitStageId} title={item.stageValue}>{item.stageValue}</Option>);
        const periodOption = (periodList || []).map(item => <Option key={item.visitPeriodId} title={item.periodValue}>{item.periodValue}</Option>)
        const visitingTypeOption = visitingTypeList.map(item => <Option key={item.visitingTypeId}>
            <Tooltip placement="right" title={item.visitingTypeName}>
                <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{item.visitingTypeName}</span>
            </Tooltip>
        </Option>);
        const compareBasicOption = compareBasicList.map(item => <Option key={item.visitTypeId}>{item.visitTypeName}</Option>);
        const categoryOption = categoryList.map(item => <Option key={item.visitCategory}>
            <Tooltip placement="right" title={item.visitCategory}>
                <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{item.visitCategory}</span>
            </Tooltip>
        </Option>);
        return (
            <Modal
                title={type == 'add' ? '添加访视' : '修改访视'}
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                confirmLoading={loading}
                maskClosable={false}
                width="500px"
            >
                <Spin spinning={loading}>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={true} colon={true}>访视阶段</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <Select
                                allowClear
                                placeholder="请选择"
                                style={{ width }}
                                value={toString(data.visitStageId)}
                                onChange={value => this.handleChange(value, 'visitStageId')}
                            >
                                { stageOption }
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text colon={true}>访视周期</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{ width }}
                                value={toString(data.visitPeriodId)}
                                onChange={value => this.handleChange(value, 'visitPeriodId')}
                            >
                                { periodOption }
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={true} colon={true}>访视类别</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{ width }}
                                value={toString(visitCategory)}
                                onChange={value => this.handleChange(value, 'visitCategory')}
                            >
                                { categoryOption }
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={true} colon={true}>访视类型</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <Select
                                allowClear
                                placeholder="请选择"
                                style={{ width }}
                                value={toString(visitingTypeId)}
                                onChange={value => this.handleChange(value, 'visitingTypeId')}
                            >
                                {visitingTypeOption}
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={false} colon={true}>访视备注</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { 
                                visible && <SearchInput
                                    isEdit={true}
                                    style={{ width }}
                                    params={{ type: 'VISIT_COMMENT' }}
                                    url={API_URL.evaluate.queryConfigWithChildByType}
                                    initValue={{ key: visitComment, label: visitComment }}
                                    keyword='configValue'
                                    filterOption={true}
                                    dataSource={visitCommentOption}
                                    parseData={this.parsevisitCommentData}
                                    handleSelect={this.visitCommentSelectChange}
                                    placeholder='输入名称检索'
                                />
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={true} colon={true}>访视工时</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <InputNumber
                                placeholder="请输入"
                                style={{ width }}
                                value={visitHour}
                                onChange={value => this.handleChange(value, 'visitHour')}
                            >
                            </InputNumber>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={true} colon={true}>访视次数</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { 
                                visible && <SearchInput
                                    isEdit={true}
                                    style={{ width }}
                                    params={{ limit: 20, visitGroupingId }}
                                    url={API_URL.evaluate.queryNotUsedVisitName}
                                    initValue={{ key: visitTypeName, label: visitTypeName }}
                                    keyword='configValue'
                                    dataSource={visitCountOption}
                                    parseData={this.parseVisitCountData}
                                    handleSelect={this.visitCountSelectChange}
                                    placeholder='输入名称检索'
                                />
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={true} colon={true}>访视时间维度</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <Select
                                style={{ width }}
                                value={data.visitTypeTimeUnit}
                                onChange={value => this.handleChange(value, 'visitTypeTimeUnit')}
                            >
                                { VisitTypeTimeUnitOption }
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text colon={true}>对照基准</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <Select
                                allowClear
                                placeholder="请选择"
                                style={{ width }}
                                value={toString(data.referenceVisitTypeId)}
                                onChange={value => this.handleChange(value, 'referenceVisitTypeId')}
                            >
                                {compareBasicOption}
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text colon={true}>访视时间点</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <InputNumber
                                precision={0}
                                placeholder="请输入"
                                style={{ width: 135 }}
                                value={data.visitTypeWindow}
                                onChange={value => this.handleChange(value, 'visitTypeWindow')}
                            />
                            <Select
                                style={{ marginLeft: 10, width: 55 }}
                                value={data.visitTypeWindowDateType}
                                onChange={value => this.handleChange(value, 'visitTypeWindowDateType')}
                            >
                                { data.visitTypeTimeUnit == 'DAY' ? DateTypeOption : HourTypeOption}
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text colon={true}>访视窗口</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <VisitWindow
                                data={data}
                                valueProp="firstWindowValue"
                                symbolProp="firstWindowSymbol"
                                onChange={this.handleChange}
                                unit={data.visitTypeTimeUnit == 'HOUR' ? '小时':'天'}
                            />
                            <VisitWindow
                                data={data}
                                style={{marginTop: 10}}
                                valueProp="secondWindowValue"
                                symbolProp="secondWindowSymbol"
                                onChange={this.handleChange}
                                unit={data.visitTypeTimeUnit == 'HOUR' ? '小时':'天'}
                            />
                        </Col>
                    </Row>
                </Spin>
            </Modal>
        );
    }
}

export default Update;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/visitPeriodPlan/components/Update.js